import styled from "styled-components";
import { FONT_SIZE_18 } from "@website-builder/utilities-index";

export const CardWrapper = styled.section`
	text-align: center;
	color: #fff;
	div {
		padding: 20px 0;
		line-height: 22px;
	}
	strong {
		display: block;
		margin-bottom: 5px;
		font-size: ${FONT_SIZE_18};
	}
`;
